// import './App.css';

import { Box, Grid, FormControl, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';

import Button from '@mui/material/Button';

import ListDialog from './ListDialog.js';

import PickNamesDialog from './PickNamesDialog.js';

import { useState } from 'react';

function Lobby ({ onPlay, nameType, names, onPickNames }) {

  const [open, setOpen] = useState(false);

  const [listOpen, setListOpen] = useState(false);

  const [pickNamesOpen, setPickNamesOpen] = useState(false);

  // const handleClickOpenInstructions = () => {
  //   setOpen(true);
  // };

  const handleCloseInstructions = () => {
    setOpen(false);
  };

  const handleClickOpenList = () => {
    setListOpen(true);
  };

  const handleClickOpenPickNames = () => {
    setPickNamesOpen(true);
  };

  function handleSubmit (event) {
    event.preventDefault();
    onPlay({ nameType: nameType });
  }

  return (<Box
    component="form"
    onSubmit={handleSubmit}
    fullWidth
  >
    <Grid container spacing={1}>
     <Grid item xs={12}>
      <FormControl fullWidth sx={{ m: 1 }}>
        <Button type="submit" fullWidth variant="contained">Play</Button>
      </FormControl>
     </Grid>
    </Grid>

    <FormControl fullWidth sx={{ m: 1 }}>
      <Button variant="text" onClick={handleClickOpenPickNames} sx={{ m: 1 }}>
        Pick Names
      </Button>
    </FormControl>

    <FormControl fullWidth sx={{ m: 1 }}>
      <Button variant="text" onClick={handleClickOpenList} sx={{ m: 1 }}>
        My Top Names
      </Button>
    </FormControl>

    {/* <FormControl fullWidth sx={{ m: 1 }}>
      <Button variant="text" onClick={handleClickOpenInstructions} sx={{ m: 1 }}>
        Instructions
      </Button> */}

    <a href="Untitled.mp4" target = "_blank">Demo</a>

    <PickNamesDialog open={pickNamesOpen} setOpen={setPickNamesOpen} list={names} onPickNames={onPickNames}/>

    <ListDialog open={listOpen} setOpen={setListOpen} list={names}/>

    <Dialog
      open={open}
      onClose={handleCloseInstructions}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"Instructions"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Press Play to continue the current game or start a new one from the full list.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseInstructions} autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>

  </Box>);
}

export default Lobby;
